import styled from "styled-components";

import { ContainerComponent } from "../../ui";

export const Wrapper = styled("section")(({ theme, variant }) => ({
  ...(variant === "full"
    ? {
        minHeight: 700,
        background: `url(/images/design/hero-bg2.png)`,
        backgroundSize: "cover",
        backgroundPosition: "center bottom",
        backgroundRepeat: "no-repeat",
      }
    : {
        backgroundColor: theme.palette.background.page,
      }),
  position: "relative",
  marginBottom: 0,

  // Cloud band at the bottom of the hero (Fly design)
  ...(variant === "full"
    ? {
        "&::after": {
          content: '""',
          position: "absolute",
          left: 0,
          bottom: -1,
          width: "100%",
          height: 220,
          background: "url(/images/design/clouds.png) center bottom / cover no-repeat",
          pointerEvents: "none",
          zIndex: 1,

          [theme.down("md")]: {
            height: 120,
          },
        },
      }
    : {}),

  [theme.down("xl")]: {
    minHeight: variant === "full" ? 500 : "auto",
  },

  [theme.down("sm")]: {
    minHeight: "auto",
  },
}));

export const WrapperContainer = styled(ContainerComponent)(({ theme }) => ({
  height: "100%",
  position: "relative",
  zIndex: 2,

  [theme.down("sm")]: {
    ...theme.paddings(20, 0, 60),
  },
}));
